import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

import 'bootstrap/dist/css/bootstrap.min.css';
export const msalInstance = new PublicClientApplication(msalConfig);

const initializeApp = async () => {
  try {
    await msalInstance.initialize();
    
    await msalInstance.handleRedirectPromise();
    
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    
    root.render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );

    reportWebVitals();
  } catch (error) {
    console.error('MSAL initialization failed:', error);
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(<App />);
  }
};

initializeApp();
